<div class="input-container"
    [style.borderColor]="showErrorBorder && errorList?.length > 0 ? null : (overrideBorderColor ? overrideBorderColor : null)"
    [class.has-error]="showErrorBorder && errorList?.length > 0"
    [class.is-disabled]="isDisabled"
    [class.is-readonly]="isReadonly">

    <input #textBox
        (blur)="blur($event)"
        (input)="onInputChange($event)"
        (ngModelChange)="valueChange($event)"
        (focus)="focus($event)"
        (focusout)="onFocusOut.emit($event)"
        (mouseenter)="mouseEnter($event)"
        (mouseleave)="mouseLeave($event)"
        (keydown)="onKeyDown.emit($event)"
        (keypress)="onKeyPress.emit($event)"
        [ngModel]="value"
        [imask]="mask"
        #popperError="popper"
        [popper]="tooltipErrTemplate"
        [popperDisabled]="!showErrorTooltip || !errorList || errorList?.length === 0"
        [popperTrigger]="ngxPopperjsTriggers.hover"
        popperApplyClass="error"
        [popperPlacement]="ngxPopperjsPlacements.TOP"
        [popperPreventOverflow]="false"
        [popperHideOnScroll]="true"
        popperAppendTo="body"
        [attr.maxlength]="maskSettings ? null : maxLength"
        [attr.tabindex]="tabIndex"
        [disabled]="isDisabled ? true: null"
        [readonly]="isReadonly ? true : null"
        [attr.placeholder]="placeholder"
        [ngClass]="customClasses"
        [class.is-disabled]="isDisabled"
        [class.is-readonly]="isReadonly"
        [class.has-commands]="customCommandList?.length > 0"
        type="text"
        spellcheck="false"
        autocomplete="autocomplete-off" />

    <div class="command-list-container"
        *ngIf="customCommandList?.length > 0"
        [class.is-disabled]="isDisabled">
        <ng-template ngFor let-command [ngForOf]="customCommandList">
            @if(command.isVisible$ | async) {
                <nts-ribbon-button [title]="command.tooltip"
                    [tabIndex]="0"
                    [isLoading]="command.loading$ | async"
                    [icon]="command.iconClass"
                    [isDisabled]="!(command.canExecute$ | async)"
                    (onClicked)="command.execute()">
                </nts-ribbon-button>
            }
        </ng-template>
    </div>
</div>

<popper-content #tooltipErrTemplate>
    <ng-container *ngFor="let item of errorList">
        {{ item }}
    </ng-container>
</popper-content>
